import { GeneralAction } from '../../../../../shared/infrastructure/store/actions/general_action';
import { PlanActionType } from '../actions/actionTypes';
import { PlanState } from '../state/state';

const Plans = (state = PlanState, action: GeneralAction<PlanActionType>) => {
    switch (action.type) {
        case PlanActionType.SET_PLAN_BY_ID:
            state = { ...state, singlePlan: action.payload, singlePlanLoading: false };
            break;
        case PlanActionType.SET_PLANS:
            state = { ...state, allPlans: action.payload };
            break;
        case PlanActionType.SET_CREATE_PLAN_ERROR:
            state = { ...state, createPlanError: action.payload };
            break;
        case PlanActionType.SET_CREATE_PLAN_LOADING:
            state = { ...state, createPlanLoading: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default Plans;
